import { Component, Input, Inject, ElementRef } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { DOCUMENT } from '@angular/common';
/**
 * fc-timelineæ¶é´è½´
 * 
 * åç´å±ç¤ºçæ¶é´æµä¿¡æ¯ã 
 * 
 * å½æä¸ç³»åä¿¡æ¯éææ¶é´æåæ¶ï¼å¯æ­£åºåååºã
 * 
 * éè¦æä¸æ¡æ¶é´è½´è¿è¡è§è§ä¸çä¸²èæ¶ã
 * 
 * äºä»¶ï¼
 * 
 * 1.éä¸­äºä»¶ï¼selected
 * 
 */
@Component({
    selector: 'fc-timeline',
    template: `
    <div [style.paddingLeft]="fcLeft" style="padding-top:5px" class="fc-timeline" [ngClass]="{'fc-timeline-left':fcLabelPosition==='left',
        'fc-timeline-right':fcLabelPosition==='right','fc-timeline-small':fcSize==='small',
        'fc-timeline-default':fcSize==='default','fc-timeline-large':fcSize==='large'}">
        <nz-timeline [nzPending]="" [ngClass]="{'fc-disabled':fcDisabled}">
            <nz-timeline-item class="fc-timeline-item" 
                *ngFor="let item of fcOption.fcValues" 
                [id]="'fcId'+item[fcOption.fcId]" 
                (click)="_select(item)" 
                [nzColor]="(item[fcOption.fcColorCode]==='normal')?'blue':(item[fcOption.fcColorCode]==='waring'?'green':'red')" 
                [ngClass]="{'active': _isActive(item[fcOption.fcId]),'fc-isread':item[fcOption.fcReadCode]==='Y',
                            'fc-noread':item[fcOption.fcReadCode]==='N'}">
                <label class="fc-timeline-label" [style.left]="fclabelLeft">{{item[fcOption.fcLabelCode]}}</label>
                <p class="fc-title">{{item[fcOption.fcTitleCode]}}</p>
                <p>{{item[fcOption.fcSmarkCode]}}</p>
            </nz-timeline-item>
        </nz-timeline>
    </div>
    `,
    styles: [`
        .fc-timeline-left .fc-timeline-label {
            cursor:pointer;
            position: absolute;
            display: block;
            text-align: right;
            padding-right: 10px;
        }
        :host ::ng-deep .ant-timeline-item{
            cursor: pointer;
        }
        :host ::ng-deep .blue.active .ant-timeline-item-tail{
            border-left:2px solid #108ee9;
        }
        :host ::ng-deep .green.active .ant-timeline-item-tail{
            border-left:2px solid #FF7712;
        }
        :host ::ng-deep .red.active .ant-timeline-item-tail{
            border-left:2px solid #f04134;
        }

        :host ::ng-deep .active .ant-timeline-item .ant-timeline-item-head-blue{
            border-color: #108ee9;
            background-color:#108ee9;
        }
        :host ::ng-deep .active .ant-timeline-item .ant-timeline-item-head-blue+.ant-timeline-item-content{
            color:#108ee9;
        }
        :host ::ng-deep .active .ant-timeline-item .ant-timeline-item-head-blue+.ant-timeline-item-content .fc-title{
            background-color:rgba(16,142,233,0.1);
        }
        :host ::ng-deep .ant-timeline-item-head-green{
            border-color: #FF7712;
            color: #FF7712;
        }
        :host ::ng-deep .active .ant-timeline-item .ant-timeline-item-head-green{
            border-color: #FF7712;
            background-color:#FF7712;
        }
        :host ::ng-deep .active .ant-timeline-item .ant-timeline-item-head-green+.ant-timeline-item-content{
            color:#FF7712;
        }
        :host ::ng-deep .active .ant-timeline-item .ant-timeline-item-head-green+.ant-timeline-item-content .fc-title{
            background-color:rgba(255,119,18,0.1);
        }
        :host ::ng-deep .active .ant-timeline-item .ant-timeline-item-head-red{
            border-color: #f04134;
            background-color:#f04134;
        }
        :host ::ng-deep .active .ant-timeline-item .ant-timeline-item-head-red+.ant-timeline-item-content{
            color:#f04134;
        }
        :host ::ng-deep .active .ant-timeline-item .ant-timeline-item-head-red+.ant-timeline-item-content .fc-title{
            background-color:rgba(240,65,52,0.1);
        }
        .fc-title{
            font-size:14px;
            margin-bottom: 10px;
            padding-left:5px;
        }
        .fc-isread .fc-title{
            font-weight: normal;
        }
        .fc-noread .fc-title{
            font-weight: bold;
        }
        :host ::ng-deep .fc-disabled .ant-timeline-item{
            cursor:pointer;
            color:#ccc;
        }
        :host ::ng-deep .fc-disabled .ant-timeline-item-head-red {
            color:#ccc;
        }
    `]
})
export class FctimelineComponent extends FcinputComponent {
    private doc: Document;
    /** æ´å¤*/
    @Input()
    fcPending: any;
    /** èªå®ä¹æ¨¡æ¿*/
    @Input()
    fcCustom: any;
    /**éç½®*/
    @Input()
    fcOption: TimelineOptions;
    /**ä½ç½®*/
    @Input()
    fcLabelPosition: string;
    /**å·¦ä¾§é´è·*/
    @Input()
    fcLeft: string;
    /**éä¸­æ¹åé¢è²*/
    @Input()
    fcSelectColor: string;
    /**éä¸­idå¼*/
    @Input()
    fcSelectedId: string;
    /**éä¸­*/
    selected: any;
    /**labelæ ç­¾å·¦ä¾§é´è·*/
    @Input()
    fclabelLeft: string;
    constructor(public provider: ProvidersService, public elementRef: ElementRef, @Inject(DOCUMENT) doc: any, ) {
        super(provider, 'fc-timeline');
        /**document*/
        this.doc = doc;
        /**é»è®¤éä¸­æ¹åé¢è²ä¸å¯ç¨*/
        if (this.fcSelectColor === undefined) {
            this.fcSelectColor = 'N';
        }
        /**é»è®¤ææ¬ä½ç½®å¨å³ä¾§*/
        if (this.fcLabelPosition === undefined) {
            this.fcLabelPosition = "right";
        }
        /**é»è®¤éä¸­IDä¸ºç©º*/
        if (this.fcSelectedId === undefined) {
            this.fcSelectedId = '';
        }
        if (this.fcDisabled === undefined) {
            this._disabled = false;
        }
    }
    _afterParentInit() {
        /** æ´å¤ä¸ºundefinedæ¶é»è®¤ä¸ºä¸å¯ç¨*/
        if (this.fcPending === undefined) {
            this.fcPending = false;
        } else {
            this.fcPending = true;
        }
        /**èªå®ä¹æ¨¡çä¸ºundefinedæ¶æ¨¡çä¸ºç©º*/
        if (this.fcCustom === undefined) {
            this.fcCustom = '';
        }
        /**ç¦ç¨æªundefinedæ¶ä¸ºfalse*/
        if (this.fcDisabled === 'Y') {
            this._disabled = true;
        } else {
            this._disabled = false;
        }
        /**è·åå°IDè·³è½¬å°æå®ä½ç½®*/
        if (this.fcSelectedId !== '') {
            this._toAnchor(this.fcSelectedId);
        }
    }
    /**
     *  éä¸­ææ¡æ°æ®æ¶è·åID
     * @param item 
     */
    _select(item) {
        this.selected = item;
        this.fcSelectedId = item[this.fcOption.fcId];
        /**éä¸­*/
        this.event("selected",item)
    };
    ngAfterViewInit() {
        /** æ¨¡æ¿ä¸­çåç´ å·²åå»ºå®æ*/
        let target = this.doc.querySelector('.fc-timeline');
    }
    /**
     * 
     * @param id 
     */
    _isActive(id) {
        return this.fcSelectedId === id;
    };
    /**
     * ç¹å»ä¾§è¾¹æ è·³è½¬å°æ¶æ¯è¯¦æé¡µé¢å¹¶è·³è½¬å°æå®ä½ç½®
     *
     * @param  location åç´ id
     * @param  wait  ç­å¾æ¯«ç§æ°
     */
    _toAnchor(location: string, wait = 200): void {
        const element = this.doc.querySelector('#fcId' + location);
        if (element) {
            setTimeout(() => {
                element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
            }, wait)
        }
    }
}
export enum TimelineColor { green, red, blue };
export interface TimelineOptions {
    /**åæ°æ®id*/
    fcAppid?: string; /**åæ°æ®id*/
    /**æ¾ç¤ºlabel*/
    fcLabelCode?: string;
    /**æ é¢*/
    fcTitleCode?: string;
    /**æè¿°*/
    fcSmarkCode?: string;
    /**é¢è²*/
    fcColorCode?: string;
    /**æ°æ®åå®¹*/
    fcValues?: any[];
    /**æ¯å¦å·²è¯»*/
    fcReadCode?: string;
    index?: number;
    fcId?: string;
}

